<!-- <app-header></app-header>-->


<div class="flex-1 flex items-center justify-center  px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0D52A0] to-gray-500 h-full">
  <div class="flex-1 flex items-center justify-center  px-4 sm:px-6 lg:px-8">
    <div class="max-w-6xl w-full flex flex-col md:flex-row bg-white shadow-lg rounded-lg overflow-hidden">

      <!-- SVG Image Section -->
      <div class="hidden md:block w-full md:w-1/2  bg-gradient-to-b  from-[#0D52A0] to-gray-50">
        <div class="h-1/2 text-center pt-12">
          <p class="text-white font-bold text-4xl">Your Gateway to Simplified Student Admissions
          </p>
          <p class="text-white font-bold text-xl mt-5">Explore 100+</p>
          <p class="text-white font-bold text-xl mt-3">Top Ranked Universities Across India</p>
          <img src="assets/images/register-org/Login.webp" alt="" class="w-full mx-auto">

        </div>
<!--        <div class=" flex items-end border">-->
<!--        </div>-->
      </div>

      <!-- Form Section -->
      <div class="w-full md:w-1/2 flex flex-col">
        <div
          class="p-8 pb-0 flex flex-col items-center justify-center bg-white rounded-t-lg md:rounded-t-none md:rounded-l-lg">
          <div
            class=" mb-2  flex items-center justify-center text-primary-600">
            <img [src]="pageExtras['profileImage'] || 'assets/img/logo/logo.png'" class="w-[50%] mx-auto " alt="Avatar"/>
            <img *ngIf="pageExtras['imageUrl']" [src]="pageExtras['imageUrl']" alt="logo" class="w-[50%]  logo-icon">

          </div>
          <h2 class="text-3xl font-semibold text-[#0D52A0] t mb-2" *ngIf="formType === 'login'" [style.font-family]="'var(--vex-font)'">Welcome <span class="text-[#BF2726]">Back!</span></h2>
          <p class="text-lg text-[#0D52A0]" *ngIf="formType === 'login'" [style.font-family]="'var(--vex-font)'">Sign in with your credentials below.</p>
<!--          <img *ngIf="pageExtras['imageUrl']" [src]="pageExtras['imageUrl']" alt="logo" class="logo-icon">-->
        </div>
        <form [formGroup]="loginForm" class="p-8 flex flex-col gap-6 bg-white" >
          <div class="flex flex-col gap-4">
            <mat-form-field  appearance="outline" [hideRequiredMarker]="true">
              <mat-label>Username</mat-label>
              <input matInput placeholder="Username" formControlName="username" required  maxlength="12" [style.font-family]="'var(--vex-font)'">
              <small class="text-red-500" *ngIf="submitted && loginForm.get('username').hasError('required')">
                Username is required
              </small>
              <small class="text-red-500" *ngIf="submitted && loginForm.get('username')?.errors?.minlength">
                Username must be at least {{loginForm.get('username')?.errors?.minlength?.requiredLength}} characters long
              </small>
            </mat-form-field>
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>Password</mat-label>
              <input [type]="inputType" formControlName="password" matInput required [style.font-family]="'var(--vex-font)'">
              <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility"
                      type="button" [style.font-family]="'var(--vex-font)'">
                <mat-icon *ngIf="visible" svgIcon="mat:visibility" [style.font-family]="'var(--vex-font)'"></mat-icon>
                <mat-icon *ngIf="!visible" svgIcon="mat:visibility_off" [style.font-family]="'var(--vex-font)'"></mat-icon>
              </button>
              <small class="text-red-500" *ngIf="submitted && loginForm.get('password').hasError('required')">
                Password is required.
              </small>
              <small class="text-red-500" *ngIf="submitted && loginForm.get('password')?.errors?.minlength">
                Password must be at least {{loginForm.get('password')?.errors?.minlength?.requiredLength}} characters long.
              </small>
            </mat-form-field>
          </div>
          <div class="flex items-center justify-between">
            <mat-checkbox color="primary" [style.font-family]="'var(--vex-font)'">Remember Me</mat-checkbox>
            <a class="text-blue-500" href="#" [style.font-family]="'var(--vex-font)'">Forgot Password?</a>
          </div>
          <button (click)="login()"
                  class="w-full py-2 mt-4 bg-[#0D52A0] text-white rounded-lg" [style.font-family]="'var(--vex-font)'">Log In
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
